var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "voice-agent-page-content" },
    [
      _c("div", { staticClass: "header-section" }, [
        _c("div", { staticClass: "title-wrapper" }, [
          _c("h1", { staticClass: "main-title" }, [
            _vm._v(_vm._s(_vm.$t("voiceagent.voiceAgents"))),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "title-description" }, [
            _vm._v(_vm._s(_vm.$t("voiceagent.voiceAgentsDescription"))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section" }, [
        _c(
          "div",
          { staticClass: "table-wrapper" },
          [
            _c("div", { staticClass: "toolbar" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("a-input-search", {
                    staticClass: "search-input",
                    staticStyle: { width: "300px", margin: "unset !important" },
                    attrs: { placeholder: _vm.$t("voiceagent.search") },
                    on: { input: _vm.onSearch },
                    model: {
                      value: _vm.searchText,
                      callback: function ($$v) {
                        _vm.searchText = $$v
                      },
                      expression: "searchText",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c(
                    "PermissionController",
                    { attrs: { permissions: ["voice-agent.create"] } },
                    [
                      _c(
                        "SupsisButton",
                        {
                          staticClass: "ai-suggest-button",
                          staticStyle: { "margin-right": "8px" },
                          attrs: { ghost: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$feature.beforeCreateVoiceAgent(
                                _vm.openAIAssistantModal,
                                _vm.agents.length
                              )
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "copilot-icon",
                            attrs: { src: "/static/img/copilot.png" },
                          }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(
                                  "voiceagent.createVoiceAgentWithSupsisAssistant"
                                )
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: { primary: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$feature.beforeCreateVoiceAgent(
                                _vm.openCreateAgentModal,
                                _vm.agents.length
                              )
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("add"),
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("voiceagent.newVoiceAgent")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "a-spin",
              { attrs: { spinning: _vm.loading } },
              [
                _c("SupsisTable", {
                  attrs: {
                    columns: _vm.getCols(),
                    rows: _vm.paginatedAgents,
                    "top-pagination": true,
                    "empty-data-bordered": "",
                    "bottom-pagination": false,
                    "pagination-cursor": _vm.pagination,
                    options: {
                      rowStyleOption: _vm.rowStyleOption,
                      clipboardOption: _vm.clipboardOption,
                      fixedHeader: true,
                      id: "agents-table",
                      borderX: true,
                      borderY: true,
                    },
                  },
                  on: {
                    "cursor-changed": function (cursor) {
                      return (_vm.pagination = cursor)
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.showCreateModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("voiceagent.createNewVoiceAgent"),
                okText: _vm.$t("voiceagent.create"),
                cancelText: _vm.$t("voiceagent.cancel"),
                xlarge: "",
              },
              on: {
                ok: _vm.createAgent,
                cancel: function ($event) {
                  _vm.showCreateModal = false
                },
              },
            },
            [
              _c("div", { staticClass: "agent-form" }, [
                _c(
                  "div",
                  { staticClass: "form-item" },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("voiceagent.agentName"))),
                    ]),
                    _vm._v(" "),
                    _c("a-input", {
                      attrs: {
                        placeholder: _vm.$t("voiceagent.enterAgentName"),
                      },
                      model: {
                        value: _vm.newAgent.agent_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.newAgent, "agent_name", $$v)
                        },
                        expression: "newAgent.agent_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-item" },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("voiceagent.voiceModel"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        model: {
                          value: _vm.newAgent.voice_model,
                          callback: function ($$v) {
                            _vm.$set(_vm.newAgent, "voice_model", $$v)
                          },
                          expression: "newAgent.voice_model",
                        },
                      },
                      _vm._l(_vm.voiceModels, function (model) {
                        return _c(
                          "a-select-option",
                          { key: model.id, attrs: { value: model.id } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(model.name) +
                                " - " +
                                _vm._s(model.description) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-item scenario-selector" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("voiceagent.readyScenario"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "scenario-options" },
                    _vm._l(_vm.scenarioOptions, function (scenario, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          class: [
                            "scenario-card",
                            { active: _vm.selectedScenario === index },
                          ],
                          style: {
                            borderLeftColor: scenario.color,
                            borderLeftWidth: "5px",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectScenario(index)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "scenario-icon" }, [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                style: { color: scenario.color },
                              },
                              [_vm._v(_vm._s(scenario.icon))]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "scenario-content" }, [
                            _c("div", { staticClass: "scenario-title" }, [
                              _vm._v(_vm._s(scenario.title)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "scenario-description" }, [
                              _vm._v(_vm._s(scenario.description)),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _vm.selectedScenario === 3
                  ? _c(
                      "div",
                      { staticClass: "form-item" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("voiceagent.customScenarioPrompt"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("a-textarea", {
                          attrs: {
                            placeholder: _vm.$t(
                              "voiceagent.writeAgentPromptHere"
                            ),
                            rows: 10,
                          },
                          model: {
                            value: _vm.customPrompt,
                            callback: function ($$v) {
                              _vm.customPrompt = $$v
                            },
                            expression: "customPrompt",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "small",
                          {
                            staticStyle: {
                              color: "#888",
                              "margin-top": "4px",
                              display: "block",
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("voiceagent.agentIdentityHelp")) +
                                "\n                "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAIAssistantModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("voiceagent.createVoiceAgentWithAiAssistant"),
                okText: _vm.$t("voiceagent.generatePrompt"),
                cancelText: _vm.$t("voiceagent.cancel"),
              },
              on: {
                ok: _vm.generateAgentPrompt,
                cancel: function ($event) {
                  _vm.showAIAssistantModal = false
                },
              },
            },
            [
              _c("div", { staticClass: "ai-assistant-form" }, [
                _c("p", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("voiceagent.describeVoiceAgentTasks")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-item" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("voiceagent.yourRequestForVoiceAgent"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("S2Textarea", {
                      attrs: {
                        placeholder: _vm.$t(
                          "voiceagent.describeVoiceAgentInDetail"
                        ),
                        rows: 8,
                      },
                      model: {
                        value: _vm.aiPromptRequest,
                        callback: function ($$v) {
                          _vm.aiPromptRequest = $$v
                        },
                        expression: "aiPromptRequest",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isGeneratingPrompt
                  ? _c(
                      "div",
                      { staticClass: "generating-prompt" },
                      [
                        _c("a-spin"),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "voiceagent.generatingVoiceAgentPromptAndName"
                              )
                            )
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.generatedAgentData
                  ? _c("div", { staticClass: "generated-prompt-container" }, [
                      _c(
                        "div",
                        { staticClass: "form-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "section-header" },
                            [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("voiceagent.generatedAgentName")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "link" },
                                  on: { click: _vm.createAgentFromGenerated },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("add"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("voiceagent.createThisAgent")
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.generatedAgentData.agent_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.generatedAgentData,
                                  "agent_name",
                                  $$v
                                )
                              },
                              expression: "generatedAgentData.agent_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-item" },
                        [
                          _c("div", { staticClass: "section-header" }, [
                            _c("h3", [
                              _vm._v(
                                _vm._s(_vm.$t("voiceagent.agentDescription"))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.generatedAgentData.description,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.generatedAgentData,
                                  "description",
                                  $$v
                                )
                              },
                              expression: "generatedAgentData.description",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "section-header" },
                            [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(_vm.$t("voiceagent.generatedPrompt"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "link" },
                                  on: { click: _vm.copyPromptToClipboard },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("content_copy"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("voiceagent.copy")) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("a-textarea", {
                            staticClass: "generated-prompt",
                            attrs: { rows: 10, readonly: "" },
                            model: {
                              value: _vm.generatedAgentData.prompt,
                              callback: function ($$v) {
                                _vm.$set(_vm.generatedAgentData, "prompt", $$v)
                              },
                              expression: "generatedAgentData.prompt",
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }